import React, { useEffect, useState, useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import UserContext from "../../services/user/user";
import HC_rounded from "highcharts-rounded-corners";

export default function ELineChart({
  currentData,
  lastData,
  title,
  style,
  isEmpty
}) {
  if (Highcharts.AST) {
    Highcharts.AST.allowedAttributes.push("data-testid");
  }

  const { lang } = useContext(UserContext);
  const [yMinValue, setYMinValue] = useState(0);
  const [zoom, setZoom] = useState(0);
  const [xAxisCat, setXAxisCat] = useState([]);

  HC_rounded(Highcharts);

  function getMinY() {
    let maxValue = 0;

    currentData.forEach((item) => {
      item.data.forEach((n) => {
        if (Math.abs(n) > maxValue) {
          maxValue = Math.abs(n);
        }
      });
    });

    lastData.forEach((item) => {
      item.data.forEach((n) => {
        if (Math.abs(n) > maxValue) {
          maxValue = Math.abs(n);
        }
      });
    });
    return maxValue;
  }

  function getXAisCats() {
    const date = new Date();
    const totalDays = 30;
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];

    let monthIndex = date.getMonth();
    let day = date.getDate();

    const xAxis = [];

    for (let i = 1; i <= totalDays; i++) {
      if (day === 1) {
        xAxis.push(months[monthIndex]);
        monthIndex -= 1;
      } else {
        xAxis.push(date.getDate());
      }
      day -= 1;
      date.setDate(date.getDate() - 1);
    }

    xAxis.reverse();
    return xAxis;
  }

  useEffect(() => {
    setYMinValue(getMinY());
    setZoom(getMinY());
    setXAxisCat(getXAisCats());
  }, [currentData, lastData]);

  const options = {
    credits: {
      enabled: false
    },
    chart: {
      type: "column",
      zoomType: "y",
      height: 300
      // marginLeft: 10,
    },
    title: {
      text: title || ""
    },
    xAxis: {
      categories: xAxisCat,
      labels: {
        style: {
          fontSize: "10px"
        },
        rotation: 0
      }
    },
    yAxis: {
      min: -zoom,
      max: zoom,
      gridLineColor: "var(--app-layer-accent-01)",
      title: {
        text: ""
      },
      labels: {
        // formatter: function (val) {
        //   return Math.abs(this.value) / 1000 === 0
        //     ? Math.abs(this.value) / 1000
        //     : Math.abs(this.value) / 1000 + "k";
        // },
        style: {
          fontSize: "12px"
        }
      }
    },
    tooltip: {
      headerFormat:
        '<div class="rev-line-table" data-testid="revenue-chart-tooltip">',
      pointFormat:
        // '<div><span style="background-color:{series.color};" class="rev-line-dot"></span><div><span style="font-weight: bold">{series.name}</span> <br /><span class="barchart-point-y">{point.y}</span> <span style="color: #00183D; opacity: 0.4;">({point.percentage:.0f}%)</span></div></div>',
        '<div data-testid="revenue-chart-tooltip-item"><span style="background-color:{series.color};" class="rev-line-dot" data-testid="revenue-chart-tooltip-dot"></span><div><span style="font-weight: bold" data-testid="revenue-chart-tooltip-series-name">{series.name}</span> <br /><span class="barchart-point-y" data-testid="revenue-chart-tooltip-value">{point.y}</span></div></div>',
      footerFormat: "</div>",
      style: {
        fontFamily: "Inter"
      },
      shared: true,
      useHTML: true,
      backgroundColor: "#f2f4f7",
      borderWidth: 0,
      borderRadius: 14,
      crosshairs: {
        color: "#00C376",
        dashStyle: "ShortDash",
        width: 2,
        borderRadius: "10px",
        zIndex: 4
      },
      followPointer: true,
      followTouchMove: true
    },
    plotOptions: {
      column: {
        stacking: "normal",
        maxPointWidth: 10,
        borderWidth: 0,
        zIndex: 3
      },
      series: {
        marker: {
          enabled: false
        },
        pointWidth: 8,
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            enabled: false
          }
        },

        events: {
          legendItemClick: function (e) {
            var visibility = this.visible ? "hidden" : "visible";
            // console.log(
            //   `${this.userOptions.name} was clicked`,
            //   e.target,
            //   visibility
            // );
            //     return false;
          }
        }
      },
      areaspline: {
        lineWidth: 0
      },
      area: {
        lineWidth: 0
      }
    },
    legend: {
      useHTML: true,
      align: "left",
      x: -38,
      verticalAlign: "bottom",
      y: -16,
      itemMarginBottom: 4,
      itemDistance: -10,
      labelFormatter: function () {
        let labelClass = this.visible
          ? "legend-label-visible"
          : "legend-label-hidden";
        const seriesName = this.name.toLowerCase().replace(/\s+/g, "-");
        return `
    <button aria-label="legend item" class="legend-item ${labelClass}" data-testid="revenue-chart-legend-item-${seriesName}">
      <span class="legend-dot" style="background-color: ${this.color};"></span>
      <span class="legend-text">${this.name}</span>
    </button>
  `;
      }
    },
    series: [...currentData, ...lastData]
  };

  return (
    <div
      className="column-chart-container"
      style={{
        opacity: isEmpty && 0.5,
        pointerEvents: isEmpty && "none"
      }}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
